export default function preventParentEvent(
	e
) {
	if(!e) return 
	e.preventDefault();
	e.stopPropagation();
	return e;
}
